export default __webpack_public_path__ + "static/andrea-logo-2d04975bb5512a8da57bd7a6e52e9ba0.png";